import React from "react";

import { Controller } from "react-hook-form";

import IconInfo from "@image/icones/DocumentsEmployers/iconInfo.svg";

import Switch from "@components/tailwindComponents/Switch";
import BlackTooltip from "@components/tooltip/BlackTooltip";

/**
 *
 * @param {Object} props
 * @param {Object} props.control
 * @param {boolean} props.readOnly
 * @param {function} props.translate
 * @returns
 */
export default function SecondaryEmploymentSwitch({
  control,
  readOnly,
  translate
}) {
  return (
    <Controller
      control={control}
      name="isSecondaryEmployment"
      defaultValue={false}
      render={({ field: { onChange, value } }) => (
        <div className="arh-mb-3 arh-mt-1 arh-flex arh-items-center arh-justify-between">
          <div className="arh-flex arh-items-center arh-gap-2">
            <span className="arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
              {translate("Emploi annexe")}
            </span>
            <BlackTooltip
              arrow
              placement="top-start"
              maxWidth="236px"
              fontSize="11px"
              borderRadius="4px"
              title={translate("secondary_employment_tooltip")}
            >
              <span className="arh-inline-flex arh-items-center">
                <img
                  src={IconInfo}
                  alt=""
                  className="arh-h-4 arh-w-4"
                />
              </span>
            </BlackTooltip>
          </div>
          <div className="arh-flex arh-items-center arh-gap-2">
            <Switch
              color="arh-bg-greenColor"
              checked={value}
              handleChange={() => onChange(!value)}
              disabled={readOnly}
            />
            <span className="arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
              {translate("Activer")}
            </span>
          </div>
        </div>
      )}
    />
  );
}
